import type { FormConfig } from '@acme/foundation';

export type SendOfferFormData = {
  contractUniqueNumber: string;
  tradeAgreementNumber: string;
  files: File[];
};

const requiredAlways = {
  when: () => true,
  set: { required: true },
} as const;

export const sendOfferFormConfig = (): FormConfig<SendOfferFormData> => ({
  id: 'send-offer-form',
  includeUnchangedFields: false,
  controls: [
    {
      id: 'contractUniqueNumber',
      label: 'Уникальный номер контракта',
      type: 'text',
      read: (ctx) => ctx?.contractUniqueNumber ?? '',
      write: { path: 'contractUniqueNumber' },
      validation: (v) =>
        typeof v === 'string' && !v.trim() ? 'Обязательное поле' : null,
      props: { placeholder: '123456789012' },
      rules: [requiredAlways],
    },
    {
      id: 'tradeAgreementNumber',
      label: 'Номер внешнеторгового договора',
      type: 'text',
      read: (ctx) => ctx?.tradeAgreementNumber ?? '',
      write: { path: 'tradeAgreementNumber' },
      validation: (v) =>
        typeof v === 'string' && !v.trim() ? 'Обязательное поле' : null,
      props: { placeholder: '123456789012' },
      rules: [requiredAlways],
    },
    {
      id: 'files',
      label: 'Загрузка документов',
      type: 'fileUpload',
      read: () => [],
      write: {
        path: 'files',
        transform: (v: unknown) =>
          Array.isArray(v) ? (v as { file: File }[]).map((u) => u.file) : [],
      },
      props: {
        label: 'Загрузка документов',
        accept: '.pdf',
        maxSize: 10,
        multiple: true,
        showInfoIcon: true,
      },
    },
  ],
});
